export default "__VITE_ASSET__CeAQvkJ8__"